import React from "react";
import { Outlet } from "react-router-dom";
import {
  DEFAULT_FOOTER_COLOR,
  DEFAULT_FOOTER_TEXT,
  DEFAULT_FOOTER_TEXT_COLOR,
  DEFAULT_LOGO_URL,
  useBranding
} from "./Branding";
import './Layout.css';

export const Layout = () => {
  const { branding } = useBranding();
  const customLogo = branding.logoUrl?.trim();
  const footerText = branding.footerText?.trim() || DEFAULT_FOOTER_TEXT;
  const footerStyle = {
    backgroundColor: branding.footerColor?.trim() || DEFAULT_FOOTER_COLOR,
    color: branding.footerTextColor?.trim() || DEFAULT_FOOTER_TEXT_COLOR,
  };

  return (
    <>
      <header>
        {customLogo ? (
          <img className="logo" alt="" src={customLogo}/>
        ) : (
          <a className="logo-link" href="https://www.mimobike.com/">
            <img className="logo" alt="Mimobike.am" src={DEFAULT_LOGO_URL}/>
          </a>
        )}
      </header>

      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <main>
        <Outlet/>
      </main>

      <footer style={footerStyle}>
        <div className='copyright'>
          {footerText}
        </div>
      </footer>
    </>
  );
}
